var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "episode_list_item"
  }, [_c('a', {
    staticClass: "episode_list_link",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "episode_list_num"
  }, [_vm._v(_vm._s(_vm.chapterText))]), _c('strong', {
    staticClass: "episode_list_title"
  }, [_vm._v(_vm._s(_vm.episodeInfo.title))]), _c('time', {
    staticClass: "episode_list_update"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.episodeInfo.createdDatetime)))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }